/**
 * Shared “already painted” direct avatar URLs (list → header).
 * Avoids waiting on Image.onload when the same asset is already on screen.
 */
import {
  getAvatarAssetKey,
  isSameAvatarAsset,
} from '@/modules/chat-matrix-fast/utils/userDataExtractor'

const warmDirectByAssetKey = new Map<string, string>()

export function rememberWarmDirectAvatar(src: string | null | undefined): void {
  if (!src || src.startsWith('blob:') || src.startsWith('data:')) {
    return
  }
  const key = getAvatarAssetKey(src)
  if (!key) {
    return
  }
  warmDirectByAssetKey.set(key, src)
}

/** Prefer a URL already decoded in the document or registered from a prior paint. */
export function findWarmDirectAvatar(src: string | null | undefined): string | null {
  if (!src) {
    return null
  }
  const key = getAvatarAssetKey(src)
  if (key) {
    const remembered = warmDirectByAssetKey.get(key)
    if (remembered) {
      return remembered
    }
  }

  if (typeof document === 'undefined') {
    return null
  }

  const images = document.images
  for (let i = 0; i < images.length; i++) {
    const img = images[i]
    if (!img.complete || img.naturalWidth <= 0) {
      continue
    }
    const painted = img.currentSrc || img.src
    if (painted && isSameAvatarAsset(painted, src)) {
      rememberWarmDirectAvatar(painted)
      return painted
    }
  }

  return null
}
